import {
  type RouteObject,
} from "react-router";
import TrainListApp from "train/list/app";
import { TrainDetailApp } from "train/detail/app";

declare let viewModel: any;

export const trainRoute: RouteObject = {
  path: "train",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: TrainListApp,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: TrainDetailApp,
  }]
};